import React from "react";
import ReactDOM from "react-dom/client"; // Note the change here
import "./index.css";
import { store } from "./store";
import * as serviceWorker from "./serviceWorker";
import "bootstrap/dist/css/bootstrap.min.css";
import App from "./App";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
const queryClient = new QueryClient();

// Create the root element using the new API
const root = ReactDOM.createRoot(document.getElementById("root"));

const render = () => {
  root.render(
    <QueryClientProvider client={queryClient}>
      <App store={store()} />

      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
};

render();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
